/**
 * Reduz a imagem para no máximo `maxSide` px no maior lado e gera JPEG no navegador.
 * Redesenhar no canvas também descarta os metadados (EXIF/GPS) antes de a foto sair do aparelho.
 */
export async function toJpeg(source: Blob | HTMLVideoElement, maxSide = 2000, quality = 0.86): Promise<{ blob: Blob; width: number; height: number }> {
  let img: CanvasImageSource;
  let w: number;
  let h: number;
  if (source instanceof Blob) {
    const bmp = await createImageBitmap(source, { imageOrientation: 'from-image' });
    img = bmp; w = bmp.width; h = bmp.height;
  } else {
    img = source; w = source.videoWidth; h = source.videoHeight;
  }
  const scale = Math.min(1, maxSide / Math.max(w, h));
  const width = Math.round(w * scale);
  const height = Math.round(h * scale);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Não foi possível processar a imagem neste navegador.');
  ctx.drawImage(img, 0, 0, width, height);
  const blob = await new Promise<Blob>((ok, fail) => canvas.toBlob((b) => (b ? ok(b) : fail(new Error('Falha ao gerar a imagem.'))), 'image/jpeg', quality));
  return { blob, width, height };
}
